export default "__VITE_ASSET__d3c92fb7__"